// This icon file is generated automatically.
var PCloseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.8 6l4.11-4.89a.12.12 0 00-.1-.2H9.58a.25.25 0 00-.2.09L6 5.03 2.61 1a.25.25 0 00-.2-.1H1.18c-.1 0-.16.13-.1.21L5.18 6l-4.1 4.89c-.06.08 0 .2.1.2h1.25c.07 0 .14-.03.2-.09l3.37-4.03L9.38 11c.04.06.11.1.19.1h1.25c.1 0 .16-.13.1-.21L6.8 6z", "fill-rule": "nonzero" } }] }, "name": "p-close", "theme": "outlined" };
export default PCloseOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCloseOutlined.js
// module id = 3291
// module chunks = 0